import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { MaterialModule } from './material.module';
import { SharedModule } from './shared.module';

import { AccountInfosComponent } from './components/account-infos/account-infos.component';
import { PhoneFormFieldComponent } from './components/inputs/phone-form-field/phone-form-field.component';

const inputs = [
  PhoneFormFieldComponent,
];

const components = [
  AccountInfosComponent,
];

@NgModule({
  imports: [
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgxDropzoneModule,
    RouterModule,
    TranslocoModule,
    TranslocoLocaleModule,
    SharedModule,
    ...inputs,
    ...components,
  ],
  exports: [
    ...inputs,
    ...components,
  ],
})
export class PhoneModule { }
